export const form = {
    name: 'Nome',
    email: 'E-mail',
    phone: 'Celular',
    state: 'Estado',
    city: 'Cidade',
    zipcode: 'CEP',
    uf: 'UF',
    role: 'Seu papel na obra',
    required: 'Obrigatório',
    invalid: 'Inválido',
    newsletter: 'Desejo receber novidades Castelatto por e-mail',
    button: 'Buscar Revendas',
    error: 'Um ou mais campos contém erro. Tente Novamente.',
    request_error: 'Desculpe, houve um erro na sua solicitação. Tente Novamente.',
    success: 'Aguarde! Estamos efetuando sua pesquisa.',
    professional: 'Profissional Especificador (Arquiteto, Designer de Interior, Paisagista, Engenheiro, etc.)',
    builder: 'Construtora, Incorporadora, Engenharia',
    consumer: 'Consumidor Final',
    others: 'Outros',
    call: 'Contato telefônico',
    header: 'Preencha o formulário e encontre a<br>loja parceira Castelatto mais próxima de você.',
    alert: '* Todos os campos são obrigatórios',
};

export const result = {
    no_results: "Estamos felizes com seu interesse em nossos produtos! <br>Em breve, você receberá o contato de um consultor Castelatto para te auxiliar em todas as etapas do seu projeto.",
    engineering_results: "Para um atendimento personalizado, aguarde o contato do nosso time de Engenharia.",
    title: 'Resultado da pesquisa',
    result: 'Revenda Próxima à você',
    thanks: 'Agradecemos seu interesse nos produtos CASTELATTO. Veja abaixo a loja mais próxima do CEP: {zipcode}',
    address: 'Endereço',
    phone: 'Telefone',
    zipcode: 'CEP',
    email: 'E-mail',
    city: 'Cidade',
    distance: 'Distância',
    how_to_get: 'Como chegar',
    button: 'VOLTAR',
    print: 'Imprimir',
    send: 'Enviar por e-mail',
    innovation: 'Inovação',
    architecture: 'Arquitetura',
    design: 'Design',
    success: 'E-mail enviado com sucesso',
    error: 'Ocorreu um erro ao enviar o seu e-mail. :/',
};
